// Import the functions you need from the SDKs you need
import firebase from "firebase";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAKLooi4ytHP03sIMf-ck3rHoTYo4zczYw",
    authDomain: "brmill.firebaseapp.com",
    databaseURL: "https://brmill.firebaseio.com",
    projectId: "brmill",
    storageBucket: "brmill.appspot.com",
    messagingSenderId: "192931598540",
    appId: "1:192931598540:web:b5913527abfad230a1b269",
    measurementId: "G-TNTCWKC8Y1"
};
// Initialize Firebase
const fb = firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();


export {fb, db}

